import { lazy } from 'react'

import { ProductMasterDetailPageRBAC } from '../pages/ProductMasterDetail/rbac'

const ProductVariantPage = lazy(() => import('../pages/ProductMasterDetail'))

export type ProductMasterNamedRoutesType = 'ProductMasterDetailRouter'
export type ProductMasterPathListsType = '/dashboard/product/detail/:productId' // change it to the same as the other

type RouterInstanceType = RouterFeatureInterface<
  ProductMasterNamedRoutesType,
  ProductMasterPathListsType
>

export const ProductMasterDetailRouter: RouterInstanceType = {
  name: 'ProductMasterDetailRouter',
  Component: ProductVariantPage,
  path: '/dashboard/product/detail/:productId',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: ProductMasterDetailPageRBAC.pageID,
  isDashboard: true,
}

const ProductMasterDetailRouters: RouterInstanceType[] = [ProductMasterDetailRouter]

export default ProductMasterDetailRouters
